<template>
  <div v-if="loaded" class="h-100">
    <div v-if="!phone">
      {{ $t('wrong_phone_number') }}
    </div>
    <div v-if="iframeLink" class="h-100">
      <iframe :src="iframeLink.url" class="w-100"></iframe>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue"
import {useStore} from "vuex"
import {WhatsappService} from "@/services/api/whatsapp.api.service"
import {formatPhone} from "@/extensions/filters/filters"

const props = defineProps({
  phone: {
    type: String,
  },
  patientId: {

  }
})

const wazzupIframe = ref('')
const loaded = ref(false)

const store = useStore()

const dynamicConfigValue = computed(() => store.getters.dynamicConfigValue)
const wazzupEnabled = computed(() => store.state.crm.wazzupEnabled)
const jetAPILink = computed(() => dynamicConfigValue.value('jetapi_iframe_url'))
const phoneFormatted = computed(() => formatPhone(props.phone, false, true))
const greenApiframeUrl = computed(() => store.getters.greenAPIIframeUrl(phoneFormatted.value))

const iframeLink = computed(() => {
  if(wazzupIframe.value) {
    return {
      url: wazzupIframe.value,
      vendor: 'wazzup'
    }
  }
  if(greenApiframeUrl.value) {
    return {
      url: greenApiframeUrl.value,
      vendor: 'greenApi'
    }
  }
  if(jetAPILink.value) {
    return {
      url: `${jetAPILink.value}&phone=${phoneFormatted.value}`,
      vendor: 'jetApi'
    }
  }
  return null
})

onMounted(async () => {
  if(props.patientId && wazzupEnabled.value) {
    await loadWazzupIframe()
  }
  loaded.value = true
})

const loadWazzupIframe = async (type = 'whatsapp') => {
  let res = await WhatsappService.createIframe(props.patientId, type)
  if(res.data.url) {
    wazzupIframe.value = res.data.url
  }
}
</script>

<style scoped lang="scss">
iframe {
  height: 100%;
  min-height: 65vh;
  border: none;
}
</style>
